import React from 'react';
import { useTranslation } from 'react-i18next';

import {
    useKeyboard,
} from '~Betslip/store/keyboardContext';

import { getLocalizedDateFormat } from '~shared/utils/date-time';
import Time from '~shared/ui/Time/Time';
import {
    DATE_TIME_FORMAT_HM_DD_MMM_YYYY,
} from '~shared/utils/constants';

import Freebet from './Freebet';

import './styles.scss';

const FreebetsContainer = () => {
    const [ t ] = useTranslation();
    const { freebets, selectedFreebet } = useKeyboard();

    if (freebets.length < 1) {
        return null;
    }

    return (
        <>
            <div className="fullslip__freebets">
                {freebets.map(freebet => {
                    return <Freebet key={freebet.id} freebet={freebet} />;
                })}
            </div>
            <div className="fullslip__freebet-expiry">
                {selectedFreebet
                    ? <span>{t('betslip.expires')}: <Time dateTime={selectedFreebet.expires_at} format={getLocalizedDateFormat(DATE_TIME_FORMAT_HM_DD_MMM_YYYY)} /></span>
                    : null
                }
            </div>
        </>
    );
};

export default FreebetsContainer;
